<template>
    <div v-cloak class="cookie-consent" v-if="visible">
        <div class="cookie-consent__bar" >
                
            {{ translations['cookie-consent-text'] }}

            <span class="mobile-block">
                <button @click="accept"
                        class="cookie-consent__btn"> {{ translations['cookie-consent-button'] }}
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14.3" ><path d="M14 7.2L6.9 0l-.6.6 6 6.1H0v.9h12.3l-6 6.1.6.6z"/></svg>

                </button>
            </span>
            
            <span class="mobile-block">
                <a class="cookie-consent__anchor" 
                href="/privacy" 
                target="_blank"> {{ translations['read-more-button'] }}
                </a>
            </span>

        </div>
        <div class="cookie-consent__backdrop"></div>
    </div>
</template>

<script>
export default {
    data: () => ({
        accepted: false
    }),
    props: {
        translations: Object,
        onPrivacyPage: Boolean
    },
    mounted: function () {
        this.setState()
    },
    methods: {
        setState: function () {
            this.accepted = (window.localStorage.getItem('accepted_cookies') === 'true')

            if (! this.visible) 
                return document.body.classList.remove('overflow-hidden')
            return document.body.classList.add('overflow-hidden')

        },
        accept: function () {
            window.localStorage.setItem('accepted_cookies', 'true')
            this.setState()
        }
    },
    computed: {
        visible: function() {

            if(this.onPrivacyPage) return false

            return  ! this.accepted
        }
    }
}
</script>

<style lang="scss" scoped>
    [v-cloak] {display: none}
    .cookie-consent {
        &__bar {
            position: fixed;
            z-index: 101;
            top: 0;
            left: 0;
            right: 0;

            background: white;
            border-bottom: 4px solid #000;
            text-align: center;
            padding: 1.2em 2em;
            font-size: 1.6rem;
        }

        &__backdrop {
            position: fixed;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: rgba(0, 0, 0, .8);
            z-index: 100;
        }
        &__btn {
            position: relative;
            margin: 0 1em;
            display: inline-block;
            padding: .3em 1.8em .3em .8em;
            font-size: inherit;
            text-transform: uppercase;
            /*background: url(/site/img/arrow.svg) no-repeat right .4em center;*/
            background-color: #FFF;
            color: #000;
            text-decoration: none;
            letter-spacing: 0.03em;
            border: 2px #000 solid;
            cursor: pointer;
            svg{
                position: absolute;
                right: 7px;
                top: 10px;
            }
        }
        &__anchor {
            color: #000;
            text-transform: lowercase;
            text-decoration: none;
            border-bottom: 1px #000 solid;
            font-size: .8em;
        }
    }

    .night{
        .cookie-consent__bar{
            background: #000;
            color: #FFF;
            border-color: #FFF;
        }
        .cookie-consent__btn, .cookie-consent__anchor{

            color: #FFF;
            border-color: #FFF;
        }

        .cookie-consent__btn{
            background: #000;
        }
        svg{
            fill: #FFF;
        }
    }

    @media only screen and (max-width: 940px) {
        .mobile-block {
            display: block;
            margin: .4em 0;
        }
    }
</style>




// WEBPACK FOOTER //
// resources/assets/js/site/components/cookie-consent.vue